import { Button, Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core/react/i18n';

import { useMarkModuleAsLoaded } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { Task } from './components/Task';
import { TaskProgressIndicator } from './components/TaskProgressIndicator';
import { useNextSteps } from './hooks/useNextSteps';

export function NextSteps() {
	const {
		data: {
			tasks,
			stats,
			showDownloadFlyerTask,
			showTaskListToggle,
			toggleTaskListLabel,
			toggleTaskListIcon,
			viewMoreRef,
			getListItemRef,
			taskListIsExpanded,
		},
		actions: { toggleTaskList },
	} = useNextSteps();
	useMarkModuleAsLoaded('NextSteps', stats.count > 0);

	if (stats.count === 0) return null;

	// Find the index of the first active task that will be rendered
	const firstActiveTaskIndex = tasks.findIndex((task) => {
		// Skip tasks that won't be rendered
		if (task.name === 'download_flyer' && !showDownloadFlyerTask) return false;
		if (task.status === 'IGNORED') return false;
		// Check if this is an active task
		return task.status === 'ACTIVE';
	});

	return (
		<div className="flex flex-col bg-background-base px-4 py-8 md:p-12">
			<div className="mb-4 flex w-full items-center">
				<div className="flex items-center gap-3">
					<Text
						className="text-size-heading-small"
						id="steps-to-victory-title"
						data-qa="steps-to-victory-title"
						as="h3"
					>
						<Translate value="corgi.petition.starter_dashboard_v2.next_steps.title" />
					</Text>
				</div>
				<div className="ml-auto">
					<TaskProgressIndicator completed={stats.completed} total={stats.count} />
				</div>
			</div>
			{tasks.map((task, index) => {
				if (task.name === 'download_flyer' && !showDownloadFlyerTask) return null;
				const isFirstActive = index === firstActiveTaskIndex;
				return (
					<div key={task.id} ref={getListItemRef(index)} tabIndex={-1} className="border-b border-stroke-weaker">
						<Task key={task.name} {...task} isFirstActive={isFirstActive} />
					</div>
				);
			})}
			{/* View more button */}
			{showTaskListToggle && (
				<Button
					variant="tertiary"
					size="small"
					onClick={toggleTaskList}
					data-qa="steps-to-victory-view-more-button"
					ref={viewMoreRef}
					className={cn('gap-1 bg-fill-transparent text-typography-strong', {
						'no-underline': taskListIsExpanded,
					})}
				>
					<Translate value={toggleTaskListLabel} />
					{toggleTaskListIcon}
				</Button>
			)}
		</div>
	);
}
